moment = require 'moment'
_ = require 'underscore'

callMaybe = (context, functionOrValue) ->
  if typeof functionOrValue == 'function'
    functionOrValue.call(context)
  else
    functionOrValue

module.exports = (fmt) ->
  fmt = _.clone(fmt)
  { sameYear, sameElse } = fmt
  delete fmt.sameYear
  fmt.sameElse = ->
    if @isSame(moment(), 'year')
      callMaybe(this, sameYear)
    else
      callMaybe(this, sameElse)
  return fmt



// WEBPACK FOOTER //
// ./app/scripts/data/moment/make-year-aware-calendar.coffee